import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'payment-link-error',
  templateUrl: './payment-link-error.component.html',
  styleUrls: ['./payment-link-error.component.scss'],
})
export class PaymentLinkErrorComponent implements OnInit {
  titleKey = 'ARC_PAYMENT_LINKS_UNEXPECTED_ERROR_TITLE';
  messageKey = 'ARC_PAYMENT_LINKS_UNEXPECTED_ERROR';

  ngOnInit(): void {
    if (history.state?.type === 'payables-closed') {
      this.titleKey = 'ARC_PAYMENT_LINKS_PAYABLES_CLOSED_TITLE';
      this.messageKey = 'ARC_PAYMENT_LINKS_PAYABLES_CLOSED';
    }
  }
}
